import React, { useEffect } from "react";
import { User } from "../types";
import { useAtom } from "jotai";
import { currentSpaceAtom, currentUserAtom } from "../jotai/atoms";
import { MAX_STREAMING_USERS, ROOM_SERVICE_MAP_KEYS } from "../consts";
import { useMap } from "@roomservice/react";
import { useOnlinesSetup, usePositions } from "../roomservice/presences";
import { useToasts } from "react-toast-notifications";
import { useUserInfos } from "../roomservice/maps";

function Presence() {
  const [currentUser] = useAtom(currentUserAtom);
  const [currentSpace] = useAtom(currentSpaceAtom);

  const [onlines, onlinesClient] = useOnlinesSetup();
  const [, positionsClient] = usePositions();
  const userInfos = useUserInfos();

  const [, currentUserInfoClient] = useMap<User>(
    currentSpace!.id,
    ROOM_SERVICE_MAP_KEYS.USER + currentUser!.id
  );

  const { addToast } = useToasts();
  const streamingUsersCount = onlines.filter(
    (id) => !!userInfos[ROOM_SERVICE_MAP_KEYS.USER + id]?.video
  ).length;

  useEffect(() => {
    if (streamingUsersCount > MAX_STREAMING_USERS) {
      addToast(
        "Too many people are streaming videos at once, consider switching to audio-only."
      );
    }
  }, [streamingUsersCount, addToast]);

  // Send current user's user info up to be accessed by others
  // TODO: replace this with actual database + long polling
  useEffect(() => {
    if (!currentUserInfoClient) return;
    currentUserInfoClient.set("id", currentUser!.id);
    currentUserInfoClient.set("name", currentUser!.name);
    currentUserInfoClient.set("color", currentUser!.color);
  }, [currentUserInfoClient, currentUser]);

  // Rebroadcast online status to stay online
  useEffect(() => {
    onlinesClient.set(true, 60 * 60 * 24); // 1 day

    const ping = setInterval(() => {
      onlinesClient.set(true, 60 * 60 * 24);
    }, 15 * 1000); // Ping every 15 seconds

    return () => {
      // RoomService will unset all presence keys when a websocket closes
      // But when changing spaces via React Router, websocket persists even though room changes
      // So we need to manually set this so users don't remain when changing spaces
      clearInterval(ping);
      console.warn("Setting online to false");
      onlinesClient.set(false, 30); // 30s expiration to account for potential clockskew
      // Move cursor positions off screen in case of any delays
      positionsClient.set({ x: -9999, y: -9999 }, 30);
    };
  }, [onlinesClient, currentSpace, positionsClient]);

  return <></>;
}

export default Presence;
